import React, { useState, useEffect } from 'react';
import Card from '../Reusable/Card';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import ContactContent from './Contact/ContactContent';
import EmailContent from './Email/EmailHistoryContent';
import APIS from '../../constant/Endpoint';
import usePatchHook from '../../customHooks/usePatchHook';

const tabTitles = {
  contact: 'Contact',
  email: 'Email',
};

const SettingsNavLinks = ({ setActiveTitle }) => {
  const [activeTab, setActiveTab] = useState('email');

  useEffect(() => {
    if (setActiveTitle) {
      setActiveTitle(tabTitles[activeTab]);
    }
  }, [activeTab, setActiveTitle]);

  const renderContent = () => {
    switch (activeTab) {
      case 'contact':
        return <ContactContent handleIsDefaultContact={handleIsDefaultContact} />;
      case 'email':
        return <EmailContent handleIsDefault={handleIsDefault} />;
      default:
        return null;
    }
  };

  const buttonClass = (email) =>
    tw` outline-none focus:outline-none focus:ring-0 ${
      activeTab === email
        ? 'border-b-2 border-primary text-primary font-semibold'
        : 'border-b-0 text-gray-600 hover:text-primary'
    }`;

  const { mutateAsync: patchStatus, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ['emails', 'contacts'],
    navigateURL: '',
  });
  const handleIsDefault = async (value: boolean, id: any) => {
    const payload = {
      is_default: value,
    };
    const url = `${APIS.SENDER_EMAIL}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsDefaultContact = async (value: boolean, id: any) => {
    const payload = {
      is_default: value,
    };
    const url = `${APIS.SENDER_SMS}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div>
      <Card>
        <div className='flex gap-4 border-b p-4 text-lg'>
          <button
            className={buttonClass('email')}
            onClick={() => setActiveTab('email')}
          >
            Sender Email
          </button>
          <button
            className={buttonClass('contact')}
            onClick={() => setActiveTab('contact')}
          >
            Sender Contact
          </button>
        </div>
      </Card>

      <div className='mt-4'>{renderContent()}</div>
    </div>
  );
};

export default SettingsNavLinks;
